// extracted by mini-css-extract-plugin
export default {"buttonContainer":"NameModal__buttonContainer___kWGNl"};